import { useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    objAscSort, objDescSort, month
} from "src/components/common/functions";

export default function BirthDayForm({
    closeIt, filterUserList
}){
    const user = useMyStore(state => state.user);
    const [currentPage, setCurrentPage] = useState(0);
    const [columnOrder, setColumnOrder] = useState({title: "", direciton: 0});
    const data = filterUserList
    .filter(f => !f.quitDate && f.birthDay)
    .map(f => ({
        userName: f.userName,
        email: f.email,
        birthYear: f.birthDay.split("-")[0], 
        birthMonth: f.birthDay.split("-")[1], 
        bd:f.birthDay.split("-").slice(1).join("-"),
        age: window.Math.floor(((new Date()) - (new Date(f.birthDay.replace(/-/g,"/"))))/1000/60/60/24/365.25),
        hireDate: f.hireDate,
        years: window.parseFloat((((new Date()) - (new Date(f.hireDate.replace(/-/g,"/"))))/1000/60/60/24/365.25).toFixed(2))
    }));
    if(columnOrder.direciton === 1){
        data.sort((a, b) => objAscSort(a, b, columnOrder.title));
    }else if(columnOrder.direciton === -1){
        data.sort((a, b) => objDescSort(a, b, columnOrder.title));
    }
    const tableData = data.filter(d => window.parseInt(d.birthMonth) === currentPage + 1);
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "BirthDay"
            width = {1000} maxWidth = {"100%"}
        >
            <div className = "h3 my-4">{month[currentPage]}</div>
            <div className = "table-responsive">
                <table className = "table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            {user.personel === "yes"?<>
                            <th
                                style = {{cursor:"pointer"}}
                                onMouseOver = {e => {e.currentTarget.style.color = "red"}}
                                onMouseLeave = {e => {e.currentTarget.style.color = "black"}}
                                onClick = {() => {
                                    if(columnOrder.title !== "birthYear"){
                                        setColumnOrder({title: "birthYear", direciton: 1});
                                    }else{
                                        if(columnOrder.direciton === 1){
                                            setColumnOrder(obj => ({...obj, direciton: -1}));
                                        }else{
                                            setColumnOrder(obj => ({...obj, direciton: obj.direciton + 1}));
                                        }
                                    }
                                }}
                            >Year of Birth {columnOrder.title === "birthYear"?<>{columnOrder.direciton === 0?<></>:(columnOrder.direciton === -1?<>↑</>:<>↓</>)}</>:<></>}</th>
                            <th
                                style = {{cursor:"pointer"}}
                                onMouseOver = {e => {e.currentTarget.style.color = "red"}}
                                onMouseLeave = {e => {e.currentTarget.style.color = "black"}}
                                onClick = {() => {
                                    if(columnOrder.title !== "bd"){
                                        setColumnOrder({title: "bd", direciton: 1});
                                    }else{
                                        if(columnOrder.direciton === 1){
                                            setColumnOrder(obj => ({...obj, direciton: -1}));
                                        }else{
                                            setColumnOrder(obj => ({...obj, direciton: obj.direciton + 1}));
                                        }
                                    }
                                }}
                            >BirthDay {columnOrder.title === "bd"?<>{columnOrder.direciton === 0?<></>:(columnOrder.direciton === -1?<>↑</>:<>↓</>)}</>:<></>}</th>
                            <th
                                style = {{cursor:"pointer"}}
                                onMouseOver = {e => {e.currentTarget.style.color = "red"}}
                                onMouseLeave = {e => {e.currentTarget.style.color = "black"}}
                                onClick = {() => {
                                    if(columnOrder.title !== "age"){
                                        setColumnOrder({title: "age", direciton: 1});
                                    }else{
                                        if(columnOrder.direciton === 1){
                                            setColumnOrder(obj => ({...obj, direciton: -1}));
                                        }else{
                                            setColumnOrder(obj => ({...obj, direciton: obj.direciton + 1}));
                                        }
                                    }
                                }}
                            >Age {columnOrder.title === "age"?<>{columnOrder.direciton === 0?<></>:(columnOrder.direciton === -1?<>↑</>:<>↓</>)}</>:<></>}</th>
                            <th
                                style = {{cursor:"pointer"}}
                                onMouseOver = {e => {e.currentTarget.style.color = "red"}}
                                onMouseLeave = {e => {e.currentTarget.style.color = "black"}}
                                onClick = {() => {
                                    if(columnOrder.title !== "hireDate"){
                                        setColumnOrder({title: "hireDate", direciton: 1});
                                    }else{
                                        if(columnOrder.direciton === 1){
                                            setColumnOrder(obj => ({...obj, direciton: -1}));
                                        }else{
                                            setColumnOrder(obj => ({...obj, direciton: obj.direciton + 1}));
                                        }
                                    }
                                }}
                            >Hire Date {columnOrder.title === "hireDate"?<>{columnOrder.direciton === 0?<></>:(columnOrder.direciton === -1?<>↑</>:<>↓</>)}</>:<></>}</th>
                            <th
                                style = {{cursor:"pointer"}}
                                onMouseOver = {e => {e.currentTarget.style.color = "red"}}
                                onMouseLeave = {e => {e.currentTarget.style.color = "black"}}
                                onClick = {() => {
                                    if(columnOrder.title !== "years"){
                                        setColumnOrder({title: "years", direciton: 1});
                                    }else{
                                        if(columnOrder.direciton === 1){
                                            setColumnOrder(obj => ({...obj, direciton: -1}));
                                        }else{
                                            setColumnOrder(obj => ({...obj, direciton: obj.direciton + 1}));
                                        }
                                    }
                                }}
                            >Years With Bess {columnOrder.title === "years"?<>{columnOrder.direciton === 0?<></>:(columnOrder.direciton === -1?<>↑</>:<>↓</>)}</>:<></>}</th>
                            </>:null}
                        </tr>
                    </thead>
                    <tbody>
                        {tableData
                        .map((d, di) => <tr key = {di}>
                            <td className = "text-nowrap">{d.userName}</td>
                            {user.personel === "yes"?<>
                            <td className = "text-nowrap">{d.birthYear}</td>
                            <td className = "text-nowrap">{d.bd}</td>
                            <td className = "text-nowrap">{d.age}</td>
                            <td className = "text-nowrap">{d.hireDate}</td>
                            <td>
                                <div style = {{display: "flex", alignItems: "center"}}>
                                    <div className = "progress" style = {{width: `${Math.trunc(window.parseFloat(d.years) /  Math.max(...tableData.map(x => window.parseFloat(x.years))) * 17)}vw`}}>
                                        <div className = "progress-bar progress-bar-striped" role = "progressbar" style = {{width: "100%"}}></div>
                                    </div>
                                    <div className = "ml-3">{d.years}</div>
                                </div>
                            </td>
                            </>:null}
                        </tr>)}
                    </tbody>
                </table>
            </div>
            <nav className = "my-2" style = {{overflow: "auto"}}>
                <ul>
                    {month.map((m, mi) => (
                    <li key = {mi} className = "page-item">
                        <span
                            style = {{background:currentPage === mi?"#e9ecef":null, cursor: "pointer"}}
                            className = "page-link"
                            onClick = {() => {
                                setCurrentPage(mi);
                            }}
                        >
                        {m}
                        </span>
                    </li>
                    ))}
                </ul>
            </nav>
        </Modal>
    )
}